"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfJurisdictionDto = instanceOfJurisdictionDto;
exports.JurisdictionDtoFromJSON = JurisdictionDtoFromJSON;
exports.JurisdictionDtoFromJSONTyped = JurisdictionDtoFromJSONTyped;
exports.JurisdictionDtoToJSON = JurisdictionDtoToJSON;
exports.JurisdictionDtoToJSONTyped = JurisdictionDtoToJSONTyped;
/**
 * Check if a given object implements the JurisdictionDto interface.
 */
function instanceOfJurisdictionDto(value) {
    if (!('abbreviation' in value) || value['abbreviation'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    return true;
}
function JurisdictionDtoFromJSON(json) {
    return JurisdictionDtoFromJSONTyped(json, false);
}
function JurisdictionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'abbreviation': json['abbreviation'],
        'name': json['name'],
    };
}
function JurisdictionDtoToJSON(json) {
    return JurisdictionDtoToJSONTyped(json, false);
}
function JurisdictionDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'abbreviation': value['abbreviation'],
        'name': value['name'],
    };
}
//# sourceMappingURL=JurisdictionDto.js.map